import { Theme, ThemeName, ThemeNameValues } from './theme';
import { cityTheme } from './themeCity';
import { cityAutumnTheme } from './themeCityAutumn';
import { cityNightTheme } from './themeCityNight';
import { citySnowTheme } from './themeCitySnow';
import { parkTheme } from './themePark';
import { parkThemeAutumn } from './themeParkAutumn';
import { parkThemeNight } from './themeParkNight';
import { parkThemeSnow } from './themeParkSnow';
import { parkThemeVariant } from './themeParkVariant';

export class ThemeUtil {
  public static themeLookup: Record<ThemeNameValues, Theme> = {
    [ThemeName.Test]: cityTheme,
    [ThemeName.City]: cityTheme,
    [ThemeName.CityAutumn]: cityAutumnTheme,
    [ThemeName.CityNight]: cityNightTheme,
    [ThemeName.CitySnow]: citySnowTheme,
    [ThemeName.Park]: parkTheme,
    [ThemeName.ParkAutumn]: parkThemeAutumn,
    [ThemeName.ParkNight]: parkThemeNight,
    [ThemeName.ParkSnow]: parkThemeSnow,
    [ThemeName.ParkVariant]: parkThemeVariant
  };

  public static getTheme = (theme: ThemeNameValues): Theme => {
    return this.themeLookup[theme];
  };
}
